import { useState, useEffect, useCallback } from 'react'
import { Modal, Row, Col, Card, Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useLoading } from '../../../hooks/LoadingContext'

import api from '../../../services/api'

import styles from './styles.module.css'

function RefuellingsModal({ show, close, vehicleId }) {
  const [refuellings, setRefuellings] = useState([])
  const { isLoading, setIsLoading } = useLoading()
  const [loadingEnded, setLoadingEnded] = useState(false)

  const gasTypeNamesMap = {
    normal_gasoline: 'gasolina comum',
    added_gasoline: 'gasolina aditivada',
    premium_gasoline: 'gasolina premium',
    formulated_gasoline: 'gasolina formulada',
    ethanol: 'etanol',
    added_ethanol: 'etanol aditivado',
    gnv: 'GNV',
    s10_diesel: 'diesel S10',
    added_diesel: 'diesel aditivado',
    premium_diesel: 'diesel premium',
  }

  function formatRefuellingDate(date) {
    date = new Date(date)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth()).padStart(2, '0')
    const year = date.getFullYear()
    const hour = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getMinutes()).padStart(2, '0')
    return `${day}/${month}/${year} às ${hour}:${minutes}:${seconds}`
  }

  const loadData = useCallback(
    async (limit = 10, offset = 0) => {
      setIsLoading(true)
      try {
        const { data } = await api.get(
          `/company/vehicles/${vehicleId}/refuellings?limit=${limit}&offset=${offset}`,
        )
        if (!data.length && offset !== 0) {
          setLoadingEnded(true)
          toast.info('Não há mais abastecimentos cadastrados para o veículo.')
        } else setRefuellings((refuellings) => [...refuellings, ...data])
      } catch (err) {
        toast.error('Falha ao buscar os dados dos abastecimentos. Tente novamente mais tarde')
        close()
      }
      setIsLoading(false)
    },
    [vehicleId, close, setIsLoading],
  )

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal centered show={show} onHide={close}>
      <Modal.Header closeButton />
      <Modal.Body className={styles.container}>
        <Row>
          {!refuellings?.length && !isLoading && (
            <span className={`${styles.infoBadge} text-center`}>
              Nenhum abastecimento cadastrado
            </span>
          )}
        </Row>

        {refuellings?.map((refuelling, index) => (
          <Card style={{ width: '100%', marginBottom: 0 }} key={index}>
            <Card.Body>
              <Card.Title
                style={{
                  fontSize: 17,
                  textAlign: 'center',
                }}
                className="mb-2 text-dark"
              >
                {refuelling.title}
              </Card.Title>
              <Card.Text style={{ fontSize: 14 }}>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>
                    {refuelling.driver ? 'Motorista: ' : 'Gestor de entregas: '}
                  </span>
                  {refuelling.driver ? refuelling.driver.name : refuelling.delivery_manager.name}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Data: </span>
                  {formatRefuellingDate(refuelling.date)}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Posto de gasolina: </span>
                  {refuelling.gas_station}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Custo: </span>
                  R$ {refuelling.cost}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Quilometragem: </span>
                  {refuelling.mileage ?? 'Não informada'}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Tipo de combustível: </span>
                  {gasTypeNamesMap[refuelling.fuel_type]}
                </p>
                <p>
                  <span style={{ fontWeight: 'bold' }}>Quantidade(litros): </span>
                  {refuelling.amount}
                </p>
              </Card.Text>
              <div className="text-center">
                <Button
                  className={`${styles.modaalBtn} ${styles.invoiceBtn}`}
                  onClick={() => window.open(refuelling.invoice_url, '_blank')}
                >
                  Nota fiscal
                </Button>
                <Button
                  className={`${styles.modaalBtn} ${styles.previousFuelBtn} mt-2 mt-sm-0`}
                  disabled={!refuelling.previous_fuel_level_url}
                  onClick={() => window.open(refuelling.previous_fuel_level_url, '_blank')}
                >
                  Nível de combustível anterior
                </Button>
              </div>
            </Card.Body>
          </Card>
        ))}
        {refuellings.length ? (
          <Col className="col-12 mt-3 mb-3 text-center">
            <Button
              className={styles.loaadMoreBtn}
              disabled={loadingEnded}
              onClick={() => {
                setIsLoading(true)
                loadData(10, refuellings.length)
                setIsLoading(false)
              }}
            >
              Carregar 10 próximos
            </Button>
          </Col>
        ) : null}
      </Modal.Body>
    </Modal>
  )
}

export default RefuellingsModal
